import(/* webpackMode: "eager" */ "/app/src/app/[locale]/annual-return/error.tsx");
